import type { ReactElement } from 'react';
import type { GetStaticProps, InferGetStaticPropsType } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { Error404PageLayout } from '@storefront/lib-content';
import { DynamicNamespaceProvider, Meta, PageType, get404PageData } from '@storefront/lib-global';

const DYNAMIC_NAMESPACE_404 = 'lib-global-common-404';

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const page404Layout = await get404PageData(locale);
  return {
    props: {
      page404Layout: page404Layout || null,
      ...(await serverSideTranslations(locale || 'en', [DYNAMIC_NAMESPACE_404])),
      dynamicNamespace: DYNAMIC_NAMESPACE_404,
    },
    revalidate: 10,
  };
};

export default function Page404({
  page404Layout,
  dynamicNamespace,
}: InferGetStaticPropsType<typeof getStaticProps>): ReactElement {
  const { t } = useTranslation([dynamicNamespace]);

  return (
    <DynamicNamespaceProvider namespace={dynamicNamespace}>
      <Meta metaTitle={t('pagenotfound.title')} pageType={PageType.ERROR} />
      <Error404PageLayout page404Layout={page404Layout} />
    </DynamicNamespaceProvider>
  );
}
